<template>
  <el-dialog
    title="请选择关联的课程"
    :visible.sync="visible"
    v-if="visible"
    :before-close="handleClose"
  >
    <div class="">
      <div style="width: 100%; text-align: center">
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="courseSearch"
          style="width: 50%; margin-right: 20px"
        >
        </el-input>
        <el-button type="primary" @click="searchCourses">搜 索</el-button>
      </div>
      <div style="padding: 20px 0; border-bottom: 1px dashed #ccc">
        <label for="" style="vertical-align: top; line-height: 30px"
          >已选课程：</label
        >
        <div
          style="
            display: inline-block;
            margin-left: 20px;
            width: calc(100% - 100px);
          "
        >
          <div v-show="selfStudy.length > 0 ? true : false">
            <label for="" style="vertical-align: top; line-height: 30px"
              >自学考试：</label
            >
            <ul style="display: inline-block; width: calc(100% - 70px)">
              <li
                style="display: inline-block"
                v-for="(study, index) in selfStudy"
                :key="index"
                class="chooseCourse"
              >
                {{ study.courseName }},
              </li>
            </ul>
          </div>
          <div v-show="adultStudy.length > 0 ? true : false">
            <label for="" style="vertical-align: top; line-height: 30px"
              >成人教育：</label
            >
            <ul style="display: inline-block; width: calc(100% - 70px)">
              <li
                style="display: inline-block"
                v-for="(study, index) in adultStudy"
                :key="index"
                class="chooseCourse"
              >
                {{ study }},
              </li>
            </ul>
          </div>
          <div v-show="netStudy.length > 0 ? true : false">
            <label for="" style="vertical-align: top; line-height: 30px"
              >网络教育：</label
            >
            <ul style="display: inline-block; width: calc(100% - 70px)">
              <li
                style="display: inline-block"
                v-for="(study, index) in netStudy"
                :key="index"
                class="chooseCourse"
              >
                {{ study }},
              </li>
            </ul>
          </div>
          <div v-show="trainStudy.length > 0 ? true : false">
            <label for="" style="vertical-align: top; line-height: 30px"
              >高端培训：</label
            >
            <ul style="display: inline-block; width: calc(100% - 70px)">
              <li
                style="display: inline-block"
                v-for="(study, index) in trainStudy"
                :key="index"
                class="chooseCourse"
              >
                {{ study }},
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div style="overflow: hidden">
        <div class="courseChoose">
          <div style="text-align: center">自考课程</div>
          <el-checkbox-group v-model="courseSelf">
            <el-checkbox
              :label="self.courseId"
              @change="selfChange"
              name="type"
              class="courses"
              v-for="(self, index) in selfList"
              :key="index"
              >{{ self.courseName }}</el-checkbox
            >
          </el-checkbox-group>
          <div
            style="text-align: center; line-height: 30px"
            v-show="selfList.length > 0 ? false : true"
          >
            无
          </div>
        </div>
        <div class="courseChoose">
          <div style="text-align: center">成人教育</div>
          <el-checkbox-group v-model="adultSelf">
            <el-checkbox
              :label="adults.courseId"
              name="type"
              @change="adultsChange"
              class="courses"
              v-for="(adults, index) in adultList"
              :key="index"
              >{{ adults.courseName }}</el-checkbox
            >
          </el-checkbox-group>
          <div
            style="text-align: center; line-height: 30px"
            v-show="adultList.length > 0 ? false : true"
          >
            无
          </div>
        </div>
        <div class="courseChoose">
          <div style="text-align: center">网络教育</div>
          <el-checkbox-group v-model="netSelf">
            <el-checkbox
              :label="net.courseId"
              name="type"
              @change="netChange"
              class="courses"
              v-for="(net, index) in netList"
              :key="index"
              >{{ net.courseName }}</el-checkbox
            >
          </el-checkbox-group>
          <div
            style="text-align: center; line-height: 30px"
            v-show="netList.length > 0 ? false : true"
          >
            无
          </div>
        </div>
        <div class="courseChoose">
          <div style="text-align: center">高端课程</div>
          <el-checkbox-group v-model="transSelf">
            <el-checkbox
              :label="trains.courseId"
              name="type"
              @change="trainsChange"
              class="courses"
              v-for="(trains, index) in trainList"
              :key="index"
              >{{ trains.courseName }}</el-checkbox
            >
          </el-checkbox-group>
          <div
            style="text-align: center; line-height: 30px"
            v-show="trainList.length > 0 ? false : true"
          >
            无
          </div>
        </div>
      </div>
    </div>
    <span
      slot="footer"
      style="width: 100%; display: inline-block; text-align: center"
    >
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { http } from '@/utils/axios'
import * as api from '@/api/courseware/coursewareList'
export default {
  props: [
    'code',
    'linkSelf',
    'linkAdult',
    'linkNet',
    'linkTrain',
    'data1',
    'data2',
    'data3',
    'data4',
  ],
  name: 'CoursewareReviewEdit',
  data() {
    return {
      mrList: true,
      searchShow: false,
      visible: false,
      courseSearch: '',
      selfStudy: [],
      selfStudy2: [],
      adultStudy: [],
      netStudy: [],
      trainStudy: [],
      courseSelf: [],
      adultSelf: [],
      netSelf: [],
      transSelf: [],
      selfList: [],
      selfList2: [],
      adultList: [],
      netList: [],
      trainList: [],
      selfMarj: [],
      adultMarj: [],
      netMarj: [],
      trainMarj: [],
      educationTypeCodes: '',
      haveSelf: [],
      allData1: [],
      allData2: [],
      allData3: [],
      allData4: [],
    }
  },
  methods: {
    searchCourses() {
      this.mrList = false
      this.searchShow = true
      // this.courseSearch
      api.searchCourseList(this.courseSearch).then(({ data }) => {
        data = data.data
        console.log(data)
        this.selfList = []
        this.adultList = []
        this.netList = []
        this.trainList = []
        for (var i = 0; i < data.length; i++) {
          if (data[i].educationTypeName == '自学考试') {
            this.selfList.push(data[i])
            // this.selfList2.push(data[i])
          } else if (data[i].educationTypeName == '成人教育') {
            this.adultList.push(data[i])
          } else if (data[i].educationTypeName == '网络教育') {
            this.netList.push(data[i])
          } else if (data[i].educationTypeName == '高端培训') {
            this.trainList.push(data[i])
          }
        }
        console.log(this.selfList)
      })
    },

    getList() {
      console.log(this.linkSelf)
      this.selfStudy = this.linkSelf
      this.adultStudy = this.linkAdult
      this.netStudy = this.linkNet
      this.trainStudy = this.linkTrain
      // this.courseSelf = this.selfStudy
      this.courseSelf = this.data1
      // this.adultSelf = this.adultStudy
      this.adultSelf = this.data2
      // this.netSelf = this.netStudy
      this.netSelf = this.data3
      // this.transSelf = this.trainStudy
      this.transSelf = this.data4
      for (let i = 0; i < this.code.length; i++) {
        this.educationTypeCodes += this.code[i] + ','
      }
      let courseIds = ''
      this.linkSelf.forEach((item) => {
        courseIds += item.courseId + ','
      })
      this.getCourseList(this.educationTypeCodes, '', courseIds)
    },

    getCourseList(educationTypeCodes, courseName, courseIds) {
      api
        .getCourseList({
          educationTypeCodes: educationTypeCodes,
          courseName: courseName,
          courseIds,
        })
        .then(({ data }) => {
          data = data.data
          console.log(data)
          for (var i = 0; i < data.length; i++) {
            if (data[i].educationTypeName == '自学考试') {
              this.selfList.push(data[i])
              // console.log(this.selfList);
              // this.selfList.push(data[i].courseName)
              this.selfMarj.push(data[i].majorName)
            } else if (data[i].educationTypeName == '成人教育') {
              this.adultList.push(data[i])
              this.adultMarj.push(data[i].majorName)
            } else if (data[i].educationTypeName == '网络教育') {
              this.netList.push(data[i])
              this.netMarj.push(data[i].majorName)
            } else if (data[i].educationTypeName == '高端培训') {
              this.trainList.push(data[i])
              this.trainMarj.push(data[i].majorName)
            }
          }
          this.allData1 = this.selfList //为搜索列表重赋值
          this.allData2 = this.adultList //为搜索列表重赋值
          this.allData3 = this.netList //为搜索列表重赋值
          this.allData4 = this.trainList //为搜索列表重赋值

          this.courseSelf = []
          for (let i = 0; i < this.linkSelf.length; i++) {
            //回显勾选的课程
            this.courseSelf.push(this.linkSelf[i].courseId)
          }
          console.log(this.courseSelf)
          for (let k = 0; k < this.linkAdult.length; k++) {
            this.adultSelf.push(this.linkAdult[i].courseId)
          }
          for (let a = 0; a < this.linkNet.length; a++) {
            this.netSelf.push(this.linkNet[i].courseId)
          }
          for (let c = 0; c < this.linkTrain.length; c++) {
            this.transSelf.push(this.linkTrain[i].courseId)
          }
        })
    },

    selfChange() {
      console.log(this.courseSelf, 'this.courseSelf')
      // this.selfStudy = this.courseSelf
      this.selfStudy = []
      // for (let i = 0; i < this.courseSelf.length; i++) {
      //   for(let j = 0;j<this.selfList.length;j++){
      //     if(this.selfList[j].courseId == this.courseSelf[i]){
      //       this.selfStudy.push(this.selfList[j])
      //     }
      //   }
      // }
      for (let i = 0; i < this.courseSelf.length; i++) {
        for (let j = 0; j < this.allData1.length; j++) {
          if (this.allData1[j].courseId == this.courseSelf[i]) {
            this.selfStudy.push(this.allData1[j])
          }
        }
      }
    },

    adultsChange() {
      // this.adultStudy = this.adultSelf
      this.adultStudy = []
      for (let i = 0; i < this.adultSelf.length; i++) {
        for (let j = 0; j < this.allData2.length; j++) {
          if (this.allData2[j].courseId == this.adultSelf[i]) {
            this.adultStudy.push(this.allData2[j])
          }
        }
        // this.adultStudy.push(this.adultList[this.adultSelf[i]])
      }
    },
    netChange() {
      // this.netStudy = this.netSelf
      this.netStudy = []
      for (let i = 0; i < this.netSelf.length; i++) {
        for (let j = 0; j < this.allData3.length; j++) {
          if (this.allData3[j].courseId == this.netSelf[i]) {
            this.netStudy.push(this.allData3[j])
          }
        }
      }
    },
    trainsChange() {
      // this.trainStudy = this.transSelf
      this.trainStudy = []
      for (let i = 0; i < this.transSelf.length; i++) {
        for (let j = 0; j < this.allData4.length; j++) {
          if (this.allData4[j].courseId == this.transSelf[i]) {
            this.trainStudy.push(this.allData4[j])
          }
        }
      }
    },
    // 初始化
    init() {
      this.visible = true
    },

    // 获取用户简表文件
    getUserFile(idCard) {},

    // 处理弹窗关闭事件
    handleClose(msg) {
      this.visible = false
      this.$emit('close-registration-review-edit', msg)
    },

    // 提交
    submitForm() {
      this.visible = false
      this.$emit('sendSelfStudy2', this.allData1)
      this.$emit('sendSelfStudy', this.courseSelf)
      this.$emit('sendAdultStudy2', this.allData2)
      this.$emit('sendAdultStudy', this.adultSelf)
      this.$emit('sendNetStudy2', this.allData3)
      this.$emit('sendNetStudy', this.netSelf)
      this.$emit('sendTrainStudy2', this.allData4)
      this.$emit('sendTrainStudy', this.transSelf)

      this.$emit('sendselfMarj', this.selfMarj)
      this.$emit('sendadultMarj', this.adultMarj)
      this.$emit('sendnetMarj', this.netMarj)
      this.$emit('sendtrainMarj', this.trainMarj)
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog {
  width: 60%;
}
.chooseCourse {
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses {
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose {
  width: 25%;
  max-height: 200px;
  overflow-y: auto;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child {
  border-right: none;
}
.el-checkbox__label {
  white-space: normal;
  padding-left: 5px;
}
</style>
